// extracted by mini-css-extract-plugin
export default {"description":"UserProfile_description__SQAB9","content":"UserProfile_content__Rpy1x","pinWeb":"UserProfile_pinWeb__sgotp","pinWeb__text":"UserProfile_pinWeb__text__hcuDl"};